import * as SERVICES_TYPES from '../../actions/services/types';

const INITIAL_STATE = {
    page: 1,
    items: [],
    search: '',
    hideArchived: true,
    showAll: false,
    loading: false,
    itemsCount: 0,
    pagesCount: 0,
};

export const servicesListReducer = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;

    switch (type) {
    case (SERVICES_TYPES.SERVICES_SET): {
        const { services, itemsCount, pagesCount } = payload;
        const page = Math.min(state.page, pagesCount || 1);
        return {
            ...state,
            items: services,
            page,
            itemsCount,
            pagesCount,
        };
    }
    case (SERVICES_TYPES.SERVICES_ITEM_RANDOMLY_SELECT_SET): {
        const { serviceId, randomlySelectEmployee } = payload;
        return {
            ...state,
            items: state.items.map((item) => {
                if (item.id === serviceId) {
                    return {
                        ...item,
                        randomlySelectEmployee,
                    };
                }
                return item;
            }),
        };
    }
    case (SERVICES_TYPES.SERVICES_ITEM_ARCHIVE_SET): {
        const { serviceId } = payload;
        return {
            ...state,
            items: state.items.map((item) => {
                if (item.id === serviceId) {
                    return {
                        ...item,
                        archived: !item.archived,
                    };
                }
                return item;
            }),
        };
    }
    case (SERVICES_TYPES.SERVICES_PAGE_SET): {
        const { page } = payload;
        return {
            ...state,
            page,
            showAll: page === 0,
        };
    }
    case (SERVICES_TYPES.SERVICES_PAGE_SET_FIRST): {
        return {
            ...state,
            page: 1,
            showAll: false,
        };
    }
    case (SERVICES_TYPES.SERVICES_PAGE_SET_LAST): {
        return {
            ...state,
            page: state.pagesCount,
            showAll: false,
        };
    }
    case (SERVICES_TYPES.SERVICES_PAGE_SET_PREV): {
        return {
            ...state,
            page: Math.max(state.page - 1, 1),
            showAll: false,
        };
    }
    case (SERVICES_TYPES.SERVICES_PAGE_SET_NEXT): {
        return {
            ...state,
            page: Math.min(state.page + 1, state.pagesCount),
            showAll: false,
        };
    }
    case (SERVICES_TYPES.SERVICES_SEARCH_SET): {
        const { search = '' } = payload;
        return {
            ...state,
            search: search.trim(),
            page: state.showAll ? 0 : 1,
        };
    }
    case (SERVICES_TYPES.SERVICES_HIDE_ARCHIVED_TOGGLE): {
        const { hideArchived } = payload;
        return {
            ...state,
            hideArchived,
        };
    }
    case (SERVICES_TYPES.SERVICES_LOADING_SET): {
        const { loading } = payload;
        return {
            ...state,
            loading,
        };
    }
    default:
        return state;
    }
};
